//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// pnpm nx run pms:generate-flags

// Description: PMS price for initial Nurse consultations
// Default On Variation: [object Object]
// Default Off Variation: [object Object]
export const FF_CONSULTATION_PRICE_JSON = 'consultation_price_json';

// Description: PMS price for follow up Doctor consultations
// Default On Variation: 29
// Default Off Variation: 59.99
export const FF_CONSULTATION_FOLLOW_UP_PRICE = 'consultation_follow_up_price';

// Description: Concession discount rate for Nurse/Doctor consultations
// Default On Variation: 15
// Default Off Variation: 0
export const FF_CONCESSION_DISCOUNT_RATE = 'concession_discount_rate';

// Description: This handles the discount code input on the payment page.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DISCOUNT_CODES = 'enable_discount_codes';

// Description: A feature flag to set the number of products shown in the product selection for doctors when adding medication
// Default On Variation: 5
// Default Off Variation: 3
export const FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT = 'prescription_recommended_products_count';

// Description: It allows you to display or hide the promo code discount line in the payment step. (Appointment Summary)
// Default On Variation: true
// Default Off Variation: false
export const FF_DISPLAY_PROMO_CODE_DISCOUNT = 'display_promo_code_discount';

// Description: a feature flag to display a short generic “info” when recommendations are shown. ie. “Product recommendations are based on your
// selections and availability criteria”.
// Default On Variation: [object Object]
// Default Off Variation: [object Object]
export const FF_PRESCRIPTION_RECOMMENDED_INFO = 'prescription_recommended_info';

// Default On Variation: [object Object]
// Default Off Variation: [object Object]
export const FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS = 'inventory_insights_enforce_greena_repeats';

// Default On Variation: true
// Default Off Variation: false
export const FF_INVENTORY_INSIGHTS_FOR_CLINICAL_TUTORIAL = 'inventory_insights_for_clinical_tutorial';

// Description: https://montugroup.atlassian.net/browse/B2CS-98 https://montugroup.atlassian.net/browse/B2CS-238
// Default On Variation: true
// Default Off Variation: false
export const FF_USE_SHOPIFY_PRODUCT_IMAGES = 'use_shopify_product_images';

// Description: Window for time period in which the user has to pay the consultation booking, in SECONDS before it times out.
// Default On Variation: 600
// Default Off Variation: 300
export const FF_CONSULTATION_BOOKING_PAYMENT_WINDOW = 'consultation_booking_payment_window';

// Description: Display an alternative cancellation modal when a consultation is in 'Pending' status.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ALTERNATE_PENDING_CANCELLATION = 'enable_alternate_pending_cancellation';

// Description: Used to roll out v4 of the prescription assistant prescribed medication
// Default On Variation: false
// Default Off Variation: false
export const FF_V4_PRESCRIPTION_ASSISTANT_CANCEL_PRESCRIBED_MEDICATION =
  'v4_prescription_assistant_cancel_prescribed_medication';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE = 'enable_google_places_autocomplete';

// Description: Enables Snowplow Tracking
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SNOWPLOW = 'enable_snowplow';

// Description: Send Notification of Treatment form to WA DoH for WA patient
// Default On Variation: true
// Default Off Variation: false
export const FF_WA_NOTIFICATION_OF_TREATMENT = 'wa_notification_of_treatment';

// Description: Feature for Immutable Notes. Removing edibility for patient Notes and adding better audit tracking to consultation notes.
// Default On Variation: true
// Default Off Variation: false
export const FF_IMMUTABLE_CLINIC_NOTES = 'immutable_clinic_notes';

// Description: toggle visibility of Consultation Notes History within a single consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_VIEW_CONSULTATION_NOTES_HISTORY = 'view_consultation_notes_history';

// Description: https://montugroup.atlassian.net/browse/B2CS-1217
// Default On Variation: true
// Default Off Variation: false
export const FF_CONSULTATION_CHARGES_UPLIFT = 'consultation_charges_uplift';

// Description: Allow booking of any doctor if current doctor is not active
// Default On Variation: true
// Default Off Variation: false
export const FF_BOOK_ANY_DOCTOR_IF_CURRENT_DOCTOR_INACTIVE = 'book_any_doctor_if_current_doctor_inactive';

// Description: Introduce blocking/non-blocking error handling framework as per RFC-019
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PMS_ERROR_HANDLING = 'enable_pms_error_handling';

// Description: Warning for when dosage entered is under the character limit.
// Default On Variation: true
// Default Off Variation: false
export const FF_PAT_PRESCRIPTION_DOSAGE_MIN_LENGTH_VALIDATION = 'pat_prescription_dosage_min_length_validation';

// Description: (Connect for Clinic) Voice call that replaces the existing Aircall
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_VOICE_CALL = 'c4c_voice_call';

// Description: When switched on, a checklist will show up at the end of the consult
// Default On Variation: true
// Default Off Variation: false
export const FF_CONSULTATION_CHECKLIST = 'consultation_checklist';

// Description: Enable devices to be prescribed via the Prescription Assistant Tool (PAT). When ON, the "Add Device" button is visible to the user.
// When OFF, the button is hidden to prevent devices being added to prescriptions.
// Default On Variation: true
// Default Off Variation: false
export const FF_PAT_ENABLE_DEVICE_PRESCRIPTION = 'pat_enable_device_prescription';

// Description: It disables the logout menu from popping up when hovering over your name in the sidebar. Helps prevent accidental logouts.
// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_SIDEBAR_LOGOUT_HOVER = 'disable_sidebar_logout_hover';

// Description: Forces payment method to be invoice instead of credit card
// Default On Variation: true
// Default Off Variation: false
export const FF_CONSULTATION_DISABLE_CREDIT_CARDS = 'consultation-disable-credit-cards';

// Default On Variation: true
// Default Off Variation: false
export const FF_NURSE_INSTANT_CONSULTATION = 'nurse-instant-consultation';

// Description: (Connect for Clinic) Controls whether or not voice call record functionality is present
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_RECORD_VOICE_CALL = 'c4c_record_voice_call';

// Description: https://montugroup.atlassian.net/browse/B2C-5680
// Default On Variation: true
// Default Off Variation: false
export const FF_CALCOM_EMBED_PARAMS = 'calcom_embed_params';

// Description: (Connect for Clinic) Video call for patient consultation which replaces the existing Coviu
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_VIDEO_CONSULT = 'c4c_video_consult';

// Description: PatientV2 Page - Patient Save only send changed p fields
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_V2_SAVE_ONLY_CHANGED_FIELDS = 'patient-v2-save-only-changed-fields';

// Description: (Connect for Clinic) Hides patient phone number for certain roles in PMS
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_HIDE_PATIENT_PHONE_NUMBER = 'c4c_hide_patient_phone_number';

// Description: Use to disable or enable Followup round robin management in PMS
// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_CALCOM_FOLLOWUP_ROUND_ROBIN_MANAGEMENT = 'disable_calcom_followup_round_robin_management';

// Description: Enable Amazon connect video consult for specific user segments
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT = 'c4c_enable_connect_video_consult';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHOW_PATIENT_STUDY_ALERT = 'show_patient_study_alert';

// Description: Feature flag to toggle the prescription tab redesign ON and OFF
// Default On Variation: true
// Default Off Variation: false
export const FF_PRESCRIPTION_TAB_REDESIGN = 'prescription_tab_redesign';

// Description: Feature Flag to toggle pre-filling of prescription pad item details such as dosage ON and OFF.
// Default On Variation: true
// Default Off Variation: false
export const FF_PAT_PREFILL_DOSAGE = 'pat_prefill_dosage';

// Description: Enable a list of users to record the Amazon Connect video consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_ENABLE_RECORD_VIDEO_CALL = 'c4c_enable_record_video_call';

// Description: This flag will toggle on the release for Shopify Payments
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHOPIFY_PAYMENT = 'enable_shopify_payment';

// Description: Enable the scheduled consult tab on the Patient page
// Default On Variation: true
// Default Off Variation: false
export const FF_GDC_RELEASE_1 = 'gdc_release_1';

// Description: https://montugroup.atlassian.net/browse/B2C-7489
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PMS_PATIENT_DETAILS_UPDATE_ENDPOINT_V3 = 'enable_pms_patient_details_update_endpoint_v3';

// Description: Feature flag to toggle the patient details V3 forms to use the skeleton instead of the full page circle spinner
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_DETAILS_SKELETON_ENABLED = 'patient_details_skeleton_enabled';

// Description: Shows a 'cancellation' option within the status dropdown for instant consulations
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CANCEL_INSTANT_CONSULTATION = 'enable_cancel_instant_consultation';

// Description: Add clinic selection to doctor onboarding form to support assigning doctors to different clinics
// Default On Variation: true
// Default Off Variation: false
export const FF_DOCTOR_ONBOARDING_CLINIC_SELECTION = 'doctor-onboarding-clinic-selection';

// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2 = 'c4c_immediate_nurse_consultation_v2';

// Description: When this flag is toggled "enabled", Doctors will have the ability to set a consultation status as "Awaiting Document" in the PMS.
// Default On Variation: true
// Default Off Variation: false
export const FF_AWAITING_DOCUMENT_DOCTOR_CONSULT_STATUS = 'awaiting_document_doctor_consult_status';

// Description: https://montugroup.atlassian.net/browse/B2C-8335
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_PAGE_AUTOSAVE_TOUR = 'patient_page_autosave_tour';

// Description: Feature flag to enable prompt on frontend when closing a consult with unsaved changes.
// Default On Variation: true
// Default Off Variation: false
export const FF_UNSAVED_CONSULTATION_CHANGES_PROMPT = 'unsaved_consultation_changes_prompt';

// Description: Feature flag to toggle the flower dispense limit phase 2 UI
// Default On Variation: true
// Default Off Variation: false
export const FF_FLOWER_DISPENSE_LIMIT_V2 = 'flower_dispense_limit_v2';

// Description: This feature flag is for the feature of switching initial payment from initial nurse consults to initial doctor
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_INITIAL_DR_PAYMENT = 'enable_initial_dr_payment';

// Description: This is a feature flag for the merge patient profiles modal uplift in PMS. Ticket: https://montugroup.atlassian.net/browse/B2C-8211
// Default On Variation: true
// Default Off Variation: false
export const FF_MERGE_PATIENT_PROFILES_UPLIFT = 'merge_patient_profiles_uplift';

// Description: Debug logic that cannot be validated locally
// Default On Variation: true
// Default Off Variation: false
export const FF_WOMBATS_DEVICE_TESTING = 'wombats_device_testing';

// Description: Feature flag to toggle the patient centric followups ON and OFF
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_CENTRIC_FOLLOWUPS = 'patient_centric_followups';

// Description: This flag is used to manage the release timings of content changes in the treatment consent form with a backend migration
// (unfortunately there is not a single source of truth for this content...)
// Default On Variation: true
// Default Off Variation: false
export const FF_TREATMENT_CONSENT_FORM_CONTENT_UPDATE = 'treatment_consent_form_content_update';

// Description: This flag when enabled includes tour functionality for the new GDC/Scheduled Consult feature
// Default On Variation: true
// Default Off Variation: false
export const FF_SCHEDULED_CONSULT_TOUR = 'scheduled_consult_tour';
